import React from "react";
import MUICheckbox from "@mui/material/Checkbox";
import { CheckboxProps as CheckboxPropsMUI } from "@mui/material/Checkbox";
import { styled, useTheme } from "@mui/system";
import { withThemeFunction } from "../styles/VaporThemeProvider";
import {
  DefaultIcon,
  CheckedIcon,
  IndeterminateIcon
} from "../Checkbox/_fic_icons";
export interface CheckboxProps extends CheckboxPropsMUI {}

const CheckboxRoot = styled(
  React.forwardRef<HTMLButtonElement, CheckboxProps>((props, ref) => {
    const theme = useTheme();
    const {
      icon = theme?.name === "fic" ? (
        <DefaultIcon disabled={props.disabled} />
      ) : (
        props.icon
      ),
      checkedIcon = theme?.name === "fic" ? (
        <CheckedIcon disabled={props.disabled} />
      ) : (
        props.checkedIcon
      ),
      indeterminateIcon = theme?.name === "fic" ? (
        <IndeterminateIcon disabled={props.disabled} />
      ) : (
        props.indeterminateIcon
      ),
      ...others
    } = props;

    return (
      <MUICheckbox
        icon={icon}
        checkedIcon={checkedIcon}
        indeterminateIcon={indeterminateIcon}
        {...others}
        ref={ref}
      />
    );
  }),
  {
    name: "Checkbox",
    slot: "Root",
    overridesResolver: (props, styles) => [styles.root]
  }
)(({ theme }) => {
  if (theme.name === "fic") {
    return {
      "&.MuiCheckbox-root": {
        color: theme.palette.primary.borderDefault,
        "&.MuiButtonBase-root": {
          padding: "0px",
          margin: "4px",
          "&.Mui-focusVisible": {
            border: "2px",
            outline: " solid " + theme.palette.primary.interactiveDefault,
            borderRadius: "4px",
            outlineOffset: "1px"
          }
        },
        "&.MuiButtonBase-root.MuiCheckbox-root": {
          color: theme.palette.primary.borderDefault
        },
        "&.MuiCheckbox-root.Mui-checked": {
          color: theme.palette.primary.interactiveDefault
        },
        "&.MuiCheckbox-root.MuiCheckbox-indeterminate": {
          color: theme.palette.primary.interactiveDefault
        }
      }
    };
  } else {
    return {
      "&.MuiCheckbox-root": {
        color: theme.palette?.primary?.primary,
        "&:hover": {
          background: "transparent"
        }
      },
      "&.MuiCheckbox-root.Mui-checked .MuiSvgIcon-root": {
        color: theme.palette?.primary?.blueColor
      },
      "&.MuiCheckbox-root.Mui-disabled .MuiSvgIcon-root": {
        color: theme.palette?.primary?.textDisabledColor
      },
      "&.MuiCheckbox-root.Mui-checked.Mui-disabled .MuiSvgIcon-root": {
        color: theme.palette?.primary?.textDisabledColor
      }
    };
  }
});
export const Checkbox = React.forwardRef<HTMLButtonElement, CheckboxProps>(
  function Checkbox(props, ref) {
    return <CheckboxRoot {...props} ref={ref} />;
  }
) as React.FC<CheckboxProps>;
